function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import GeoJSON from 'ol/format/GeoJSON';
// From file-upload bundle
import { LayerHelper } from '../../file-upload/service/LayerHelper';
import { FileService } from '../../file-upload/service/FileService';

/**
 * Adds internal variables and injects files to features
 * @param {Array} features input features that will be enhanced with file links etc
 * @param {Function} callback returns processed features via callback
 */
export var processFeatures = function processFeatures(features, callback) {
  var processedFeatures = [];
  // file listing is async so we need to gather results before calling original callback
  var receiveResult = function receiveResult(feat) {
    processedFeatures.push(feat);
    if (processedFeatures.length === features.length) {
      callback(processedFeatures);
    }
  };
  features
  // normalize features between clicked and mass selection
  .map(function (feat) {
    var isMassSelection = !feat.geojson;
    if (isMassSelection) {
      // mass selection doesn't include geojson
      return _objectSpread({}, feat);
    }
    // feature was clicked -> read geojson to get coordinates
    var value = _objectSpread({
      _$layerId: feat.layerId
    }, feat.geojson.features[0].properties);
    var coordinates = new GeoJSON().readFeatures(feat.geojson).map(function (f) {
      return f.getGeometry().getFirstCoordinate();
    });
    if (coordinates.length) {
      value._$coord = coordinates[0];
    }
    return value;
  })
  // attach file links when available
  .forEach(function (feat) {
    return addFilesForFeature(feat, receiveResult);
  });
};
function addFilesForFeature(feature, callback) {
  var layerId = feature._$layerId;
  var attachmentFieldName = LayerHelper.getAttachmentIdFieldName(layerId);
  if (!attachmentFieldName) {
    // not found
    callback(feature);
    return;
  }
  var featureId = feature[attachmentFieldName];
  FileService.listFilesForFeature(layerId, featureId, function (files) {
    if (!files.length) {
      // no attachments
      callback(feature);
      return;
    }
    feature._$files = files;
    callback(feature);
  });
}
;